<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>
                    <el-select v-model="query.department" size="small" style="width: 120px;" placeholder="科室">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="item in departmentList" :key="item.departmentId" :value="item.departmentId" :label="item.departmentName"></el-option>
                    </el-select>
                    <el-input size="small"
                              placeholder="请输入员工姓名"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-left: 20px"
                              v-model="query.doctorName">
                    </el-input>
                    <el-input size="small" placeholder="请输入员工手机号"
                              suffix-icon="el-icon-search"
                              style="width: 220px;margin-left: 20px"
                              v-model="query.mobile">
                    </el-input>
                </div>
                <div>
                    <el-button type="primary" @click="getUser" style="width: 132px">医生/科室设置</el-button>
                </div>
            </div>
            <el-table :data="tableData"
                      v-loading="loading"
                      :header-cell-style="{'padding-left': '2%'}"
                      :cell-style="{'padding-left': '2%'}">
                <el-table-column prop="doctorName" label="医生姓名"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="departmentName" label="科室"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" class="mr20" @click="openSet(scope.row)">配置科室</el-button>
                        <el-button type="text" class="delete-button" @click="deleteDoctor(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="医生/科室设置" :visible.sync="dialogVisible" width="630px" :close-on-click-modal="false">
            <div style="margin-left: 8px">
                <span>所处科室:</span>
                <el-select v-model="departmentId" size="small" style="width: 180px;margin-left: 10px" placeholder="所处科室">
                    <el-option v-for="item in departmentList" :key="item.departmentId" :value="item.departmentId" :label="item.departmentName"></el-option>
                </el-select>
            </div>
            <div style="text-align: center;margin-top: 20px">
                <el-transfer
                        style="text-align: left; display: inline-block"
                        v-model="userIdList"
                        filterable
                        filter-placeholder="搜索员工姓名"
                        ref="user"
                        :titles="['员工', '当前已选择']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                         }"
                        :props="{
                            key: 'userId',
                            label: 'realName',
                        }"
                        :data="userList">
                    <span slot-scope="{ option }">{{ option.realName }}</span>
                </el-transfer>
            </div>
            <div slot="footer" class="dialog-footer">
                <div>
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmAdd">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="设置科室" :visible.sync="dialogEditVisible" width="520px" :close-on-click-modal="false">
            <el-form :model="doctorEdit" ref="doctorEdit" label-width="80px">
                <el-form-item label="所处科室:" prop="departmentId">
                    <el-select v-model="doctorEdit.departmentId" size="small" style="width: 280px;">
                        <el-option v-for="item in departmentList" :key="item.departmentId" :value="item.departmentId" :label="item.departmentName"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false" style="width: 76px">取消</el-button>
                <el-button type="primary" @click="departmentSet" style="width: 76px;">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                // token
                authorization:localStorage.getItem('authorization'),
                departmentList: [],
                // 搜索
                query: {
                    department: '',
                    doctorName: '',
                    mobile: '',
                },
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                // 列表数据
                loading: true,
                tableData: [],
                // 医生/科室新增
                dialogVisible: false,
                userList: [],
                departmentId: '',
                userIdList: [],
                // 医生科室修改
                dialogEditVisible: false,
                doctorEdit: '',

            };
        },
        created() {
            this.getData();
            this.getDepartment()
        },
        methods: {
            // 列表数据
            getData() {
                this.loading = true
                let params = {
                    doctorName: this.query.doctorName,
                    mobile: this.query.mobile,
                    departmentId: this.query.department,
                }
                this.axios.post('api-b/10041/100158/' + this.pageNum + '/' +this.pageSize,params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length !== 0) {
                            this.tableData = res.data.data.list
                            this.total = res.data.data.total
                        } else {
                            this.$message.info('暂无数据')
                            this.tableData = []
                            this.total = 0
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        this.total = 0
                    }
                    this.loading = false
                }).catch(() => {
                    this.tableData = []
                    this.total = 0
                    this.loading = false
                })
            },
            // 列表换页
            handlePageChange(val) {
                this.pageNum = val
                this.getData()
            },
            // 获取科室
            getDepartment() {
                let params = {
                    pageNum: 1,
                    pageSize: 999
                }
                this.axios.post('api-b/10035/100112',params,{
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list !==null) {
                            this.departmentList = res.data.data.list
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 获取员工
            getUser() {
                let params = {
                    pageNum: 1,
                    pageSize: 999,
                }
                this.axios.post('/api-u/10024/100121',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res =>{
                    if(res.data.code === 10000) {
                        this.dialogVisible = true
                        this.userIdList = []
                        if (res.data.data.list !== null) {
                            this.userList = res.data.data.list
                        } else {
                            this.userList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                        this.userList = []
                    }
                })
            },
            // 确认新增
            confirmAdd() {
                if (this.departmentId === '') {
                    this.$message.error('请选择科室')
                } else {
                    let list = []
                    for (let i=0;i<this.userIdList.length;i++) {
                        let doctor = this.userList.find(item => {
                            return item.userId === this.userIdList[i]
                        })
                        list.push({
                            doctorId: doctor.userId,
                            doctorName: doctor.realName,
                            mobile: doctor.mobile,
                        })
                    }
                    this.axios.post('api-b/10041/100139/' + this.departmentId,list,{
                        headers:{
                            Authorization: this.authorization
                        }
                    }).then(res => {
                        if (res.data.code === 10000) {
                            this.$message.success(res.data.message)
                            this.getData()
                            this.dialogVisible = false
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            },
            openSet(data) {
                this.doctorEdit = JSON.parse(JSON.stringify(data))
                this.dialogEditVisible = true
            },
            departmentSet() {
                let params = {
                    doctorId: this.doctorEdit.doctorId,
                    departmentId: this.doctorEdit.departmentId,
                }
                this.axios.post('api-b/10041/100159',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.dialogEditVisible = false
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            deleteDoctor(data) {
                let params = new FormData()
                params.append('doctorId',data.doctorId)
                this.axios.post('api-b/10041/100160',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.getData()
                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        watch: {
            query: {
                handler() {
                    this.pageNum = 1
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getData();
                    }, 300);
                },
                deep: true
            }
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
</style>